"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var deleteItems_1 = require("./deleteItems");
var blockLastSendersHelper_1 = require("./helpers/blockLastSendersHelper");
var getSweepableMailboxes_1 = require("./helpers/getSweepableMailboxes");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var itemId_1 = require("owa-service/lib/factory/itemId");
var owa_trace_1 = require("owa-trace");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Block the sender smtp addresses from the given item ids
 * @param itemIdToBlock the item id
 */
function blockLastSenderFromReadingPane(itemId, instrumentationContexts) {
    if (!itemId) {
        owa_trace_1.trace.error('blockLastSendersFromReadingPane should not be called on invalid items.');
        return;
    }
    // De-duped senders
    var mailboxes = getSweepableMailboxes_1.getSweepableMailboxesFromItemIds([itemId]);
    blockLastSendersHelper_1.default(mailboxes, function () {
        deleteItemUponBlock(itemId, instrumentationContexts);
    });
}
exports.default = blockLastSenderFromReadingPane;
var deleteItemUponBlock = legacy_1.action('deleteItemUponBlock', datapoints_1.default.blockSenderFromReadingPaneDatapoint)(function deleteItemUponBlock(itemIdToBlock, instrumentationContexts) {
    var disposalType = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')
        ? 'HardDelete'
        : 'MoveToDeletedItems';
    return deleteItems_1.deleteItemFromReadingPane(itemId_1.default({ Id: itemIdToBlock }), disposalType, 'NonUserAction' /* actionSource */, instrumentationContexts);
});
//# sourceMappingURL=blockLastSenderFromReadingPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/blockLastSenderFromReadingPane.js
// module id = 5665
// module chunks = 62